import { render, staticRenderFns } from "./RotuloSeplag.vue?vue&type=template&id=47f724f9&scoped=true&"
import script from "./RotuloSeplag.vue?vue&type=script&lang=js&"
export * from "./RotuloSeplag.vue?vue&type=script&lang=js&"
import style0 from "./RotuloSeplag.vue?vue&type=style&index=0&id=47f724f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f724f9",
  null
  
)

export default component.exports